
if (typeof Function.prototype.bind === 'undefined') {
  Function.prototype.bind = function (context) {
    var params = ([]).slice.call(arguments, 1);
    var fn = this;
    return function () {
      var allParams = params.concat(([]).slice.call(arguments, 0));
      return fn.apply(context, allParams);
    };
  };
};
module.exports = function anonymous(locals, escape, include, rethrow
/*``*/) {
escape = escape || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"c-noVideo\">\n    <div class=\"linkbox\"><div  class=\"link\"></div></div>\n    <div class=\"poster\" style=\"position: relative;background-image: url(")
    ; __append(escape(options.poster))
    ; __append(");\">\n\n    </div>\n    <div class=\"info\">\n        <p class=\"title\">")
    ; __append(escape(options.title))
    ; __append("</p>\n        <div class=\"state\">\n            ")
    ;  if(isLive == '0'){ 
    ; __append("\n            <span class=\"status prefield\">预告</span>\n            ")
    ;  }else if(isLive == '1'){ 
    ; __append("\n            <span class=\"status active\">直播中</span>\n            ")
    ;  }else{ 
    ; __append("\n            <span class=\"status end\">回放</span>\n            ")
    ;  } 
    ; __append("\n        </div>\n    </div>\n\n</div>\n\n\n")
  }
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/modules/noVideo/noVideo.ejs
// module id = 520
// module chunks = 0